/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_ReopenedInputs */

const vi_einvoice_reopened = /** @type {(inputs: Einvoice_ReopenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã mở lại đơn`)
};

/**

* @param {Einvoice_ReopenedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_reopened = /** @type {((inputs?: Einvoice_ReopenedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_ReopenedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_reopened(inputs)
});